/**
 * 票链云 — 实体类型
 *
 * 这些类型描述**序列化后**的形状（API 响应里的样子），
 * 因此时间统一为 ISO 字符串、ID 统一为 string，便于前后端直接共用。
 * 数据库行的形状（snake_case、Date 对象）由 server 端的 repository 负责映射。
 */
/**
 * 条件分支表达式（文档 4.3 条件分支）
 * 支持金额阈值、风险等级、发票类型、供应商类型，以及合同类型、费用类型。
 *
 * ⚠ **`field` 必须与流程变量同名**（引擎按点路径从 `flow_instance.variables` 取值）。
 * 这条曾经踩过：发票流程写入的变量叫 `amountCents`，而配置界面里可选的条件字段叫
 * `amount`，于是金额阈值分支**永远不命中**——引擎取到 `undefined`、转数字得 `NaN`，
 * 按设计记一条 warn 后返回 false，界面上看不出任何异常。
 * 因此新增流程在写变量时必须用 `FLOW_AMOUNT_VARIABLE` 这个统一名字。
 */
export const FLOW_AMOUNT_VARIABLE = 'amount';
/**
 * 条件字段 → 该字段在哪些业务类型下真的有值。
 *
 * 【为什么要有这张表】
 * 配置界面把可选字段全列出来，但**不是每个流程都会写**每一个变量。
 * 选了一个永远取不到值的字段，分支静默失效——比不提供该选项危险得多。
 * 服务端在保存模板时按这张表校验，界面上也只展示当前业务类型可用的字段。
 */
export const FLOW_CONDITION_FIELDS_BY_BIZ = {
    INVOICE: ['amount', 'riskLevel', 'invoiceType'],
    CONTRACT: ['amount', 'contractType'],
    EXPENSE_APPLY: ['amount', 'expenseType'],
    EXPENSE_REIMBURSE: ['amount', 'expenseType'],
};
/**
 * 条件字段的取值类型：`amount` 一律是**分**的整数，
 * 其余是业务枚举的字符串码。校验与界面渲染都按这张表决定单位与选项。
 */
export const FLOW_CONDITION_FIELD_KIND = {
    amount: 'MONEY',
    riskLevel: 'ENUM',
    invoiceType: 'ENUM',
    supplierType: 'ENUM',
    contractType: 'ENUM',
    expenseType: 'ENUM',
};
//# sourceMappingURL=types.js.map